module.exports = __webpack_public_path__ + "img/ep2-5.1a061ccc.png";